import _classCallCheck from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import Header from '../Header';
import './style';

var Page404 =
/*#__PURE__*/
function (_Component) {
  _inherits(Page404, _Component);

  function Page404(props) {
    var _this;

    _classCallCheck(this, Page404);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Page404).call(this, props));

    _this.goBack = function () {
      window.history.back();
    };

    _this.state = {};
    return _this;
  }

  _createClass(Page404, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        React.createElement("article", null,
        /*#__PURE__*/
        React.createElement(Header, null, "404"),
        /*#__PURE__*/
        React.createElement("section", {
          className: "page404"
        },
        /*#__PURE__*/
        React.createElement("img", {
          src: require('./imgs/icon-404.png'),
          alt: "\u4E91\u6C83\u5BA2",
          key: "page404"
        }),
        /*#__PURE__*/
        React.createElement("p", {
          key: "page404-txt"
        }, "\u5F88\u62B1\u6B49\uFF0C\u8BE5\u7F51\u9875\u65E0\u6CD5\u8BBF\u95EE... \u4F60\u8FD8\u53EF\u4EE5",
        /*#__PURE__*/
        React.createElement("span", {
          onClick: this.goBack
        }, "\u9000\u56DE\u4E00\u6B65"))))
      );
    }
  }]);

  return Page404;
}(Component);

export default Page404;